import AppHeader from '../AppHeader'

export default {
  name: 'master-shop-hold-on-place-list',
  created () {
    this.getShops()
    this.getHoldPlace()
    this.getCategories()
  },
  data () {
    return {
      holdPlaces: [],
      shops: [],
      categories: [],
      shopId: '',
      consumableItemName: '',
      categoryId: '',
      holdPlaceName: '',
      getShopsEndFlag: false,
      searchEndFlag: false,
      getCategoriesEndFlag: false
    }
  },
  computed: {},
  components: {
    AppHeader
  },
  methods: {
    async getShops () {
      let data = {}
      let res = await this.$store.dispatch('GET_SHOP_TARGET_STOCK', data)
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })

      this.shops = res.data
      this.getShopsEndFlag = true
    },
    async getCategories () {
      let data = {}
      const res = await this.$store.dispatch('GET_CATEGORY_LIST', data)
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })

      this.categories = res.categories
      this.getCategoriesEndFlag = true
    },
    async getHoldPlace () {
      this.searchEndFlag = false

      let data = {
        shop_id: this.shopId,
        consumable_item_name: this.consumableItemName,
        category_id: this.categoryId,
        hold_on_place_name: this.holdPlaceName
      }
      let res = await this.$store.dispatch('GET_HOLDPLACE_LIST', data)
      .catch(err => {
        console.log(err)
        return
      })

      this.holdPlaces = res.hold_places
      this.searchEndFlag = true
    },
    judgeDisplay (index) {
      if (index == 0) {
        return 'bg-light' 
      } else if (this.holdPlaces[index].shop_name) {
        return 'bg-light'
      } else {
        return ''
      }     
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/master-shop-hold-on-place-list.js